import { apiGet, apiBasic } from "./requests";

export const getSalesChannels = (query) => {
  let path = "sales-channels/";
  return apiGet(path, query);
};

export const createSalesChannel = (data) => {
  let path = "sales-channels/";
  return apiBasic(data, path, "post");
};

export const updateSalesChannel = (id, data) => {
  let path = `sales-channel/${id}/`;
  return apiBasic(data, path, "patch");
};

export const toggleChannelActiveStatus = (salesChannelId) => {
  let path = `sales-channel/${salesChannelId}/toogle-active-status`;
  return apiBasic({}, path, "post");
};

// Eliminar canales  por lote
export const deleteSalesChannelBatch = (salesChannelIds) => {
  let path = "sales-channels/delete-batch";
  return apiBasic({ salesChannelIds }, path, "delete");
};
